/*
* API URLs
*/
export const XRPSCAN_API_URL = 'https://api.xrpscan.com/api/v1';
export const XRPSCAN_WSS_URL = 'https://ws.xrpscan.com';
export const GA_TRACKING_ID = 'G-X9R71TB1SV';
export const XRPL_SERVER_VERSIONS = ['2.4.0'];
export const REACT_APP_AVATAR_CACHE_KEY = process.env.REACT_APP_AVATAR_CACHE_KEY || 1;
